export default __webpack_public_path__ + "static/media/opizeIcon.08008b34.png";